import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MatTab, MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs'

import { TabComponent } from '@ui/Components/Tabs/Tab.Component'

type AdditionalDataCallback = () => void | Promise<void>

type AdditionalCallbackCallback = (data: any) => void | Promise<void>

export interface TabIndexChangedEvent {
	index: number
}

export interface Tab {
	label: string
	component: {
		instance: any
		additionalData?: { [key: string]: any | AdditionalDataCallback }
		additionalCallbacks?: { [key: string]: AdditionalCallbackCallback }
	}
}

@Component({
	selector: 'tabs',
	templateUrl: './Tabs.Component.html',
	imports: [MatTab, MatTabGroup, TabComponent],
})
export class TabsComponent {
	@Input() public tabs: Tab[] = []

	@Input() public selectedIndex: number = 0

	@Output()
	private readonly selectedTabIndexChanged: EventEmitter<TabIndexChangedEvent> =
		new EventEmitter<TabIndexChangedEvent>()

	public tabTracker = (index: number): number => index

	public selectedTabChange = (event: MatTabChangeEvent): void => {
		this.selectedTabIndexChanged.emit({
			index: event.index,
		})
	}
}
